import * as React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ArticleTopicSubscriberListing } from '../../../amorg-common';
import { articlesClientApi } from '../../../api/articlesClientApi';
import { LinkButton } from '../../../designSystem/button/LinkButton';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { H1 } from '../../../designSystem/typography/Heading';
import { ArticlesTab } from './_components/ArticlesTab';
import { FilteredArticleTable } from './_components/FilteredArticleTable';
import { AmorgyPageWrapper } from '../../_pageWrappers/AmorgyPageWrapper';
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';
import { ButtonRow } from '../../../designSystem/button/ButtonRow';

export default function ArticlesSubscriber (): JSX.Element 
{
    const { subscriberId } = useParams<{ subscriberId: string; }>();
    const [subscriberListing, setSubscriberListing] = React.useState<ArticleTopicSubscriberListing | null>(null);
    const [loading, setLoading] = React.useState<boolean>(true);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const listId = queryParams.get('lid'); // Replace 'someQueryParam' with your parameter name

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const subscribers = await articlesClientApi.getSubscriberListings();
            setSubscriberListing(subscribers.find(s => s.subscriberId === subscriberId) || null);
            setLoading(false);
        };
        getData();
    }, []);

    return (
        <AmorgyPageWrapper selectedTab='articles'
            subMenuContent={
                <ArticlesTab selectedTab='subscribers' />
            }>

            <LoadingPageOverlay loading={loading} />
            <SingleColumnLayout>
                {subscriberListing !== null &&
                    <>
                        <ButtonRow variant="left-aligned">
                            <LinkButton variant='text' href="/amorgy/articles/subscribers" text="Tilbage til oversigten" />
                        </ButtonRow>
                        <Flex flexDirection="column" gap={16}>
                            <H1>Abonnement for {subscriberListing?.siteId || '...'}</H1>
                            <FilteredArticleTable subscriberId={subscriberId} listId={listId || ''} preview goTo />
                        </Flex>
                    </>
                }
            </SingleColumnLayout>

        </AmorgyPageWrapper>
    );
}